import { Box, DataList, Flex, Heading, Text } from '@radix-ui/themes'
import type { ReactNode } from 'react'

interface LeakV0PanelBoxProps {
  title: ReactNode
  action?: ReactNode
  children: ReactNode
}

export const LeakV0PanelBox = ({ title, action, children }: LeakV0PanelBoxProps) => (
  <Box className="rounded-[var(--radius-3)] border border-[color:var(--gray-6)] p-3">
    <Flex direction="column" gap="2">
      <Flex align="center" justify="between" gap="3">
        <Heading as="h3" size="2">
          {title}
        </Heading>
        {action}
      </Flex>
      {children}
    </Flex>
  </Box>
)

interface LeakV0DetailRowProps {
  label: string
  value: ReactNode
}

export const LeakV0DetailRow = ({ label, value }: LeakV0DetailRowProps) => (
  <DataList.Item>
    <DataList.Label>{label}</DataList.Label>
    <DataList.Value>
      {value === null || value === undefined || value === '' ? <Text color="gray">—</Text> : value}
    </DataList.Value>
  </DataList.Item>
)
